import React from 'react';
import styled, {css} from 'styled-components';
import SVG, {Props as SVGProps} from 'react-inlinesvg';
import {transformSizePropToSize} from '../../utils/common';
import {BaseIconContainer} from './styled';
import questionCircle from '../../assets/icons/icon-question-circle.svg';
import whiteArrowRight from '../../assets/icons/arrowNext.svg';
import trash from '../../assets/icons/rubbish-bin.svg';
import camera from '../../assets/icons/camera.svg';
import picture from '../../assets/icons/picture-icon.svg';
import close from '../../assets/icons/close-icon.svg';
import padlock from '../../assets/icons/padlock.svg';
import backArrow from '../../assets/icons/back-arrow.svg';
import arrowRightBlue from '../../assets/icons/arrow-right-icon-blue.svg';
import thunder from '../../assets/icons/tunder_icon.svg';
import editIcon from '../../assets/icons/edit-icon.svg';
import questionCircleBlue from '../../assets/icons/question-icon.svg';
import warningSecondary from '../../assets/icons/warning-secondary.svg';
import checkSecondary from '../../assets/icons/check-secondary.svg';
import creditCardBlue from '../../assets/icons/credit-card-blue2.svg';
import checkOutCalendar from '../../assets/icons/check-out-calendar.svg';
import checkInCalendar from '../../assets/icons/check-in-calendar.svg';
import multiGuest from '../../assets/icons/multi-guest.svg';
import backBlueArrow from '../../assets/icons/back-blue-arrow.svg';
import information from '../../assets/icons/information.svg';
import plus from '../../assets/icons/plus-icon.svg';
import languageIcon from '../../assets/icons/language-icon.svg';
import lockIcon from 'assets/icons/lock-icon.svg';
import homeSidebar from '../../assets/icons/home-sidebar.svg';
import keySidebar from '../../assets/icons/key-sidebar.svg';
import languageSidebar from '../../assets/icons/language-sidebar.svg';
import locationSidebar from '../../assets/icons/location-sidebar.svg';
import lockSidebar from '../../assets/icons/lock-sidebar.svg';
import onlineChekinSidebar from '../../assets/icons/online-chekin-sidebar.svg';
import checkFill from '../../assets/icons/check-fill.svg';
import shoppingCart from '../../assets/icons/shopping-cart.svg';
import blackMenu from '../../assets/icons/black-menu.svg';
import closeBlack from '../../assets/icons/close-black.svg';
import allianzShieldIcon from '../../assets/icons/allianz-shield-icon.svg';
import checkedBlack from '../../assets/icons/checked.svg';
import informationGray from 'assets/icons/information-gray.svg';
import allianzBlockShield from '../../assets/icons/allianz-block-shield.svg';
import threeDots from '../../assets/icons/three-dots.svg';
import insuranceCwd from '../../assets/icons/insurance-cwd.svg';
import remoteAccessBuilding from '../../assets/icons/remote-access-building.svg';
import remoteAccessApartment from '../../assets/icons/remote-access-apartment.svg';
import doubleArrow from '../../assets/icons/double-arrow.svg';
import warningError from '../../assets/icons/warning-error.svg';
import notFoundHouse from '../../assets/img/not-found-house.svg';
import iconRegister from '../../assets/icons/empty-state.svg';
import errorModalIcon from 'assets/icons/error.svg';
import dots from '../../assets/icons/dots.svg';
import autoFill from '../../assets/icons/new-auto-filled-icon.svg';
import arrowLeft from 'assets/icons/arrow-left.svg';
import questionMarkIcon from '../../assets/icons/question-blue-circle.svg';
import guestCircle from '../../assets/icons/guest-circle.svg';
import grayRightArrow from '../../assets/icons/gray-right-arrow.svg';
import keyCircle from '../../assets/icons/key-circle.svg';
import shareArrow from '../../assets/icons/share-arrow.svg';
import shoppingCartCircle from '../../assets/icons/shopping-car-circle.svg';
import arrowDates from '../../assets/icons/arrow-dates.svg';
import successCircle from '../../assets/icons/success-circle.svg';
import image from '../../assets/icons/image.svg';
import blueTickIcon from '../../assets/icons/credit-card-blue-tick.svg';
import redXIcon from 'assets/icons/credit-card-red-x.svg';
import copyLink from '../../assets/icons/copy-link.svg';
import addItem from '../../assets/icons/add-item.svg';
import wifi from '../../assets/icons/guidebooks/wifi-icon.svg';
import accessibility from '../../assets/icons/guidebooks/accessibility-icon.svg';
import arrowLocation from '../../assets/icons/guidebooks/arrow-location.svg';
import bag from '../../assets/icons/guidebooks/bag.svg';
import guideBookMainIcon from '../../assets/icons/guidebooks/guidebook-main-icon.svg';
import guidebookIcon from '../../assets/icons/guidebooks/guidebook-icon.svg';
import elevator from '../../assets/icons/guidebooks/elevator.svg';
import noSmoking from '../../assets/icons/guidebooks/no-smoking.svg';
import gym from '../../assets/icons/guidebooks/gym.svg';
import garage from '../../assets/icons/guidebooks/garage.svg';
import checkedBadge from '../../assets/icons/guidebooks/checked-badge.svg';
import checkedBadgeTwo from '../../assets/icons/guidebooks/checked-badge-two.svg';
import greetHand from '../../assets/icons/guidebooks/greet-hand.svg';
import home from '../../assets/icons/guidebooks/home.svg';
import location from '../../assets/icons/guidebooks/location.svg';
import phone from '../../assets/icons/guidebooks/phone.svg';
import plane from '../../assets/icons/guidebooks/plane.svg';
import emptyStateCart from '../../assets/img/empty-state-cart.svg';
import emptyStateList from '../../assets/img/empty-state-list.svg';
import tag from '../../assets/icons/tag.svg';
import magnifierGray from '../../assets/icons/magnifier-gray.svg';
import arrow from '../../assets/icons/arrow-down.svg';
import unavailableBooks from '../../assets/icons/unavailable-books.svg';
import download from '../../assets/icons/download-icon.svg';
import shareDownload from '../../assets/icons/share-download.svg';
import deleteItemBox from '../../assets/icons/delete_item_box.svg';
import calendar from '../../assets/icons/calendar.svg';
import experiencesUnits from '../../assets/icons/experiences-units.svg';
import ticketCircle from '../../assets/icons/ticket-circle.svg';
import minus from '../../assets/icons/minus.svg';
import dotList from '../../assets/icons/guidebooks/dot-list.svg';
import openBook from '../../assets/icons/guidebooks/open-book.svg';
import map from '../../assets/icons/guidebooks/map.svg';
import checkList from '../../assets/icons/guidebooks/check-list.svg';
import layout from '../../assets/icons/guidebooks/layout.svg';
import aboutPeople from '../../assets/icons/guidebooks/about-people.svg';
import weather from '../../assets/icons/guidebooks/weather.svg';
import infoFilled from '../../assets/icons/info-filled.svg';
import sheet from '../../assets/icons/guidebooks/sheet.svg';
import attractions from '../../assets/icons/guidebooks/attractions.svg';
import apartments from '../../assets/icons/guidebooks/apartments.svg';
import restaurant from '../../assets/icons/guidebooks/restaurant.svg';
import acDual from '../../assets/icons/guidebooks/ac-dual.svg';
import airConditioner from '../../assets/icons/guidebooks/air-conditioner.svg';
import babyChangingRoom from '../../assets/icons/guidebooks/baby-changing-room.svg';
import bagTwo from '../../assets/icons/guidebooks/bag-2.svg';
import bed from '../../assets/icons/guidebooks/bed.svg';
import boardGames from '../../assets/icons/guidebooks/board-games.svg';
import bug from '../../assets/icons/guidebooks/bug.svg';
import chairWheels from '../../assets/icons/guidebooks/chair-wheels.svg';
import cleaning from '../../assets/icons/guidebooks/cleaning.svg';
import closetHanger from '../../assets/icons/guidebooks/closet-hanger.svg';
import coffeeMaker from '../../assets/icons/guidebooks/coffee-maker.svg';
import coffee from '../../assets/icons/guidebooks/coffee.svg';
import coldMode from '../../assets/icons/guidebooks/cold-mode.svg';
import crib from '../../assets/icons/guidebooks/crib.svg';
import fan from '../../assets/icons/guidebooks/fan.svg';
import fireplace from '../../assets/icons/guidebooks/fireplace.svg';
import fridge from '../../assets/icons/guidebooks/fridge.svg';
import hairDryer from '../../assets/icons/guidebooks/hair-dryer.svg';
import health from '../../assets/icons/guidebooks/health.svg';
import heat from '../../assets/icons/guidebooks/heat.svg';
import homeStorage from '../../assets/icons/guidebooks/home-storage.svg';
import iron from '../../assets/icons/guidebooks/iron.svg';
import kettle from '../../assets/icons/guidebooks/kettle.svg';
import kingBed from '../../assets/icons/guidebooks/king-bed.svg';
import laundryMachine from '../../assets/icons/guidebooks/laundry-machine.svg';
import luggageTwo from '../../assets/icons/guidebooks/luggage-2.svg';
import luggage from '../../assets/icons/guidebooks/luggage.svg';
import metro from '../../assets/icons/guidebooks/metro.svg';
import microwave from '../../assets/icons/guidebooks/microwave.svg';
import microwaveTwo from '../../assets/icons/guidebooks/microwave-2.svg';
import outdoorGrill from '../../assets/icons/guidebooks/outdoor-grill.svg';
import oven from '../../assets/icons/guidebooks/oven.svg';
import petFriendly from '../../assets/icons/guidebooks/pet-friendly.svg';
import pool from '../../assets/icons/guidebooks/pool.svg';
import roomService from '../../assets/icons/guidebooks/room-service.svg';
import securityCamera from '../../assets/icons/guidebooks/security-camera.svg';
import securityPerson from '../../assets/icons/guidebooks/security-person.svg';
import security from '../../assets/icons/guidebooks/security.svg';
import shopping from '../../assets/icons/guidebooks/shopping.svg';
import shower from '../../assets/icons/guidebooks/shower.svg';
import sofa from '../../assets/icons/guidebooks/sofa.svg';
import spa from '../../assets/icons/guidebooks/spa.svg';
import stockpot from '../../assets/icons/guidebooks/stockpot.svg';
import train from '../../assets/icons/guidebooks/train.svg';
import tv from '../../assets/icons/guidebooks/tv.svg';
import vacuum from '../../assets/icons/guidebooks/vacuum.svg';

export type IconNames =
  | 'whiteArrowRight'
  | 'trash'
  | 'camera'
  | 'picture'
  | 'close'
  | 'padlock'
  | 'backArrow'
  | 'arrowRightBlue'
  | 'editIcon'
  | 'thunder'
  | 'questionCircleBlue'
  | 'warningSecondary'
  | 'checkSecondary'
  | 'creditCardBlue'
  | 'checkOutCalendar'
  | 'checkInCalendar'
  | 'multiGuest'
  | 'backBlueArrow'
  | 'plus'
  | 'information'
  | 'languageIcon'
  | 'lockIcon'
  | 'homeSidebar'
  | 'keySidebar'
  | 'languageSidebar'
  | 'locationSidebar'
  | 'lockSidebar'
  | 'onlineChekinSidebar'
  | 'checkFill'
  | 'shoppingCart'
  | 'blackMenu'
  | 'closeBlack'
  | 'allianzShieldIcon'
  | 'checkedBlack'
  | 'informationGray'
  | 'allianzBlockShield'
  | 'threeDots'
  | 'insuranceCwd'
  | 'notFoundHouse'
  | 'iconRegister'
  | 'errorModalIcon'
  | 'dots'
  | 'autoFill'
  | 'arrowLeft'
  | 'remoteAccessBuilding'
  | 'remoteAccessApartment'
  | 'doubleArrow'
  | 'warningError'
  | 'questionMarkIcon'
  | 'guestCircle'
  | 'grayRightArrow'
  | 'keyCircle'
  | 'shareArrow'
  | 'shoppingCartCircle'
  | 'arrowDates'
  | 'successCircle'
  | 'image'
  | 'blueTickIcon'
  | 'redXIcon'
  | 'copyLink'
  | 'addItem'
  | 'wifi'
  | 'accessibility'
  | 'elevator'
  | 'no-smoking'
  | 'gym'
  | 'garage'
  | 'checkedBadge'
  | 'checkedBadgeTwo'
  | 'greetHand'
  | 'home'
  | 'location'
  | 'phone'
  | 'plane'
  | 'questionCircle'
  | 'arrowLocation'
  | 'bag'
  | 'guideBookMainIcon'
  | 'guidebookIcon'
  | 'emptyStateCart'
  | 'emptyStateList'
  | 'tag'
  | 'magnifierGray'
  | 'arrow'
  | 'unavailable-books'
  | 'download'
  | 'shareDownload'
  | 'deleteItemBox'
  | 'calendar'
  | 'experiencesUnits'
  | 'ticketCircle'
  | 'minus'
  | 'dot-list'
  | 'open-book'
  | 'map'
  | 'check-list'
  | 'layout'
  | 'about-people'
  | 'weather'
  | 'info-filled'
  | 'sheet'
  | 'attractions'
  | 'apartments'
  | 'restaurant'
  | 'ac-dual'
  | 'air-conditioner'
  | 'baby-changing-room'
  | 'bag'
  | 'bed'
  | 'board-games'
  | 'bug'
  | 'chair-wheels'
  | 'cleaning'
  | 'closet-hanger'
  | 'coffee-maker'
  | 'coffee'
  | 'cold-mode'
  | 'crib'
  | 'fan'
  | 'fireplace'
  | 'fridge'
  | 'hair-dryer'
  | 'health'
  | 'heat'
  | 'home-storage'
  | 'iron'
  | 'kettle'
  | 'king-bed'
  | 'laundry-machine'
  | 'luggage'
  | 'metro'
  | 'microwave'
  | 'outdoor-grill'
  | 'oven'
  | 'pet-friendly'
  | 'pool'
  | 'room-service'
  | 'security-camera'
  | 'security-person'
  | 'security'
  | 'shopping'
  | 'shower'
  | 'sofa'
  | 'spa'
  | 'stockpot'
  | 'train'
  | 'tv'
  | 'vacuum'
  | 'microwave-two'
  | 'luggage-two'
  | 'bag-two';

export type IconsHash = {
  [K in IconNames]: string;
};

const icons: IconsHash = {
  questionCircle,
  whiteArrowRight,
  trash,
  camera,
  picture,
  close,
  padlock,
  backArrow,
  arrowRightBlue,
  editIcon,
  thunder,
  questionCircleBlue,
  warningSecondary,
  checkSecondary,
  creditCardBlue,
  checkOutCalendar,
  checkInCalendar,
  multiGuest,
  backBlueArrow,
  information,
  plus,
  languageIcon,
  lockIcon,
  homeSidebar,
  keySidebar,
  languageSidebar,
  locationSidebar,
  lockSidebar,
  onlineChekinSidebar,
  checkFill,
  shoppingCart,
  blackMenu,
  closeBlack,
  allianzShieldIcon,
  checkedBlack,
  informationGray,
  allianzBlockShield,
  threeDots,
  insuranceCwd,
  remoteAccessBuilding,
  remoteAccessApartment,
  doubleArrow,
  warningError,
  notFoundHouse,
  iconRegister,
  errorModalIcon,
  dots,
  autoFill,
  arrowLeft,
  questionMarkIcon,
  guestCircle,
  grayRightArrow,
  keyCircle,
  shareArrow,
  shoppingCartCircle,
  arrowDates,
  successCircle,
  image,
  blueTickIcon,
  redXIcon,
  copyLink,
  addItem,
  wifi,
  accessibility,
  elevator,
  'no-smoking': noSmoking,
  gym,
  garage,
  checkedBadge,
  checkedBadgeTwo,
  greetHand,
  home,
  location,
  phone,
  plane,
  arrowLocation,
  bag,
  guideBookMainIcon,
  guidebookIcon,
  emptyStateCart,
  emptyStateList,
  tag,
  magnifierGray,
  arrow,
  'unavailable-books': unavailableBooks,
  download,
  shareDownload,
  deleteItemBox,
  calendar,
  experiencesUnits,
  ticketCircle,
  minus,
  'dot-list': dotList,
  'open-book': openBook,
  map,
  'check-list': checkList,
  layout,
  'about-people': aboutPeople,
  weather,
  'info-filled': infoFilled,
  sheet,
  attractions,
  apartments,
  restaurant,
  'ac-dual': acDual,
  'air-conditioner': airConditioner,
  'baby-changing-room': babyChangingRoom,
  bed,
  'board-games': boardGames,
  bug,
  'chair-wheels': chairWheels,
  cleaning,
  'closet-hanger': closetHanger,
  'coffee-maker': coffeeMaker,
  coffee,
  'cold-mode': coldMode,
  crib,
  fan,
  fireplace,
  fridge,
  'hair-dryer': hairDryer,
  health,
  heat,
  'home-storage': homeStorage,
  iron,
  kettle,
  'king-bed': kingBed,
  'laundry-machine': laundryMachine,
  'luggage-two': luggageTwo,
  luggage,
  metro,
  microwave,
  'microwave-two': microwaveTwo,
  'outdoor-grill': outdoorGrill,
  oven,
  'pet-friendly': petFriendly,
  pool,
  'room-service': roomService,
  'security-camera': securityCamera,
  'security-person': securityPerson,
  security,
  shopping,
  shower,
  sofa,
  spa,
  stockpot,
  train,
  tv,
  vacuum,
  'bag-two': bagTwo,
};

export type IconProps = {
  name: IconNames;
  title?: string;
  className?: string;
  size?: string | number;
  color?: string;
  custom?: boolean;
} & React.HTMLAttributes<SVGElement> &
  React.HTMLAttributes<SVGProps>;

const StyledSVGIcon = styled(SVG)<{
  src: string;
  color?: string;
  size?: string | number;
  $custom?: string;
}>`
  width: ${props => transformSizePropToSize(props.size) || '24px'};
  height: ${props => transformSizePropToSize(props.size) || '24px'};
  fill: ${props => props.color || 'none'};
  color: ${props => props.color || 'none'};

  ${props => {
    if (props.color && props.color !== 'transparent') {
      return css`
        &:not(.chekin-empty-state__icon):not(.guest-register-view__icon-register):not(
            .error-view__icon
          ):not(.autofill-modal-sheet__icon) {
          path {
            fill: ${props.color};
          }
        }
      `;
    }
  }}

  ${props => {
    return props.$custom
      ? css`
          --icon-color: ${props.color || props.theme.colors.branding.icons};

          .system-path {
            fill: ${props.color || props.theme.colors.branding.icons};
          }
          #path-group {
            path,
            rect {
              fill: ${props.color || props.theme.colors.branding.icons};
            }
          }
          // styles for No register Guest svg AND 3 dots menu icon svg
          #empty-state-register-guest-linear-1,
          #empty-state-register-guest-linear-2,
          #sigle-dot-icon-linear-1,
          #sigle-dot-icon-linear-2,
          #sigle-dot-icon-linear-3,
          .auto-fill-icon-linear,
          .linear-svg-group {
            .stop-one {
              stop-color: ${props.color || props.theme.colors.branding.icons};
            }

            .stop-two {
              stop-color: ${props.color || props.theme.colors.branding.icons};
              opacity: 0.3;
            }
          }
          // end styles for No register Guest svg
          // styles for Error modal svg
          .primary-svg-color {
            fill: ${props.color || props.theme.colors.branding.icons};
            stroke: ${props.color || props.theme.colors.branding.icons};
            opacity: 0.3;
          }
          .secondary-svg-color {
            fill: ${props.color || props.theme.colors.branding.icons};
            stroke: ${props.color || props.theme.colors.branding.icons};
          }
          //end styles for Error modal svg

          .vector_1 {
            stroke: #dcdcdc;
            fill: none;
          }
          .vector_2 {
            stroke: #dcdcdc;
            fill: none;
          }

          .circle-background {
            fill: ${props.theme.colors.branding.backgroundSecondary};
          }
        `
      : css`
          .system-path,
          path {
            fill: ${props.color || props.theme.colors.branding.icons};
          }
        `;
  }}
`;

const CustomIcon = (props: IconProps) => {
  return (
    <BaseIconContainer size={props.size} className="custom-icon">
      <StyledSVGIcon
        src={icons[props.name]}
        size={props.size}
        width={props.size}
        height={props.size}
        title={props.title || props.name}
        color={props.color || 'transparent'}
        className={'custom-icon__icon ' + props.className}
        $custom={props.custom ? 'true' : 'false'}
      />
    </BaseIconContainer>
  );
};

export {CustomIcon};
